"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _colors = require("HubStyleTokens/colors");

var _getFeatureDescriptionKey = _interopRequireDefault(require("self-service-api/core/utilities/getFeatureDescriptionKey"));

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var TableRow = _styledComponents.default.tr.withConfig({
  displayName: "ProductCatalogTableRow__TableRow",
  componentId: "s9ofds-0"
})([":nth-child(even){background-color:", ";}:nth-child(odd){background-color:", ";}:hover{background-color:", " !important;}"], _colors.OLAF, _colors.GYPSUM, _colors.KOALA);

var LeftHeaderCell = _styledComponents.default.th.withConfig({
  displayName: "ProductCatalogTableRow__LeftHeaderCell",
  componentId: "s9ofds-1"
})(["height:40px;& > p{margin-bottom:0;font-weight:500;}text-align:center;width:18.75%;min-width:175px;:nth-child(2){width:25%;text-align:left;}"]);

var UserIconCell = _styledComponents.default.th.withConfig({
  displayName: "ProductCatalogTableRow__UserIconCell",
  componentId: "s9ofds-2"
})(["height:40px;width:2%;min-width:30px;& > p{margin-left:10px;margin-bottom:0;}"]);

var UserIcon = function UserIcon(freeUserAccess, showTooltip) {
  return _react.default.createElement("p", null, _react.default.createElement(_UITooltip.default, {
    disabled: !showTooltip,
    placement: "right",
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "pricing-pages.freeUser." + freeUserAccess
    })
  }, _react.default.createElement(_UIIcon.default, {
    className: "m-right-1",
    name: "contacts"
  })));
};

var ProductCatalogTableRow = function ProductCatalogTableRow(_ref) {
  var featureId = _ref.featureId,
      children = _ref.children,
      hub = _ref.hub,
      freeUserAccess = _ref.freeUserAccess,
      _ref$showTooltip = _ref.showTooltip,
      showTooltip = _ref$showTooltip === void 0 ? true : _ref$showTooltip;
  return _react.default.createElement(TableRow, {
    key: featureId
  }, _react.default.createElement(UserIconCell, null, freeUserAccess && UserIcon(freeUserAccess, showTooltip)), _react.default.createElement(LeftHeaderCell, null, _react.default.createElement("p", {
    style: showTooltip ? {
      cursor: 'help'
    } : {}
  }, _react.default.createElement(_UITooltip.default, {
    placement: "right",
    disabled: !showTooltip,
    title: _react.default.createElement(_FormattedMessage.default, {
      message: (0, _getFeatureDescriptionKey.default)(featureId, hub)
    })
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricing-pages.features." + featureId + ".name"
  })))), children);
};

ProductCatalogTableRow.propTypes = {
  featureId: _propTypes.default.string.isRequired,
  children: _propTypes.default.node.isRequired,
  hub: _propTypes.default.oneOf(Object.keys(_Hubs.default).map(function (hubKey) {
    return _Hubs.default[hubKey];
  })).isRequired,
  freeUserAccess: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  showTooltip: _propTypes.default.bool
};
var _default = ProductCatalogTableRow;
exports.default = _default;
module.exports = exports.default;